module.exports = __webpack_public_path__ + "img/20210730_122445.c11afa32.jpg";